import { render } from "./BlankPageSalesNine.vue?vue&type=template&id=21dae948&scoped=true"
import script from "./BlankPageSalesNine.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesNine.vue?vue&type=script&lang=js"

import "./BlankPageSalesNine.vue?vue&type=style&index=0&id=21dae948&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dae948"]])

export default __exports__